import { getAdjacentObjectsRequests } from './Request.js'
import RequestAdjacentObjectsRequests from './RequestAdjacentObjectsRequests.vue'

export const requestActionsAskAdjacentRequests = {
  methods: {
    askAdjacentRequests: async function (approveText,
      requestId = this.request.requestId || this.request.id,
      objectId = this.request.serviceObjectId || this.request.objectId,
      objectType = (this.request.serviceObject ? this.request.serviceObject.type.key : null) || this.request.objectType,
      adjacentRequests = null) {
      const objectName = this.request && this.request.serviceObject
        ? this.request.serviceObject.name
        : this.request
          ? this.request.object || 'текущим(и)'
          : 'текущим(и)'
      const requests = adjacentRequests || await getAdjacentObjectsRequests(objectId, requestId)
      return new Promise((resolve) => {
        this.$d_ask({
          callback: (data, action) => {
            if (action === '__showRequests') {
              const dialog = this.$d.dialog(this).show({
                maximized: true,
                persistent: true,
                headerLabel: 'Заявки на смежных объектах',
                contentComponent: RequestAdjacentObjectsRequests,
                contentProps: {
                  requestId,
                  objectId,
                  objectType,
                  serviceObjectName: objectName,
                  requests

                },
                componentHandlers: {
                  close: async () => {
                    dialog.hide()
                    resolve(await this.askAdjacentRequests(approveText, requestId, objectId, null, adjacentRequests = requests))
                  }
                },
                onCancel: async () => {
                  dialog.hide()
                  resolve(await this.askAdjacentRequests(approveText, requestId, objectId, null, adjacentRequests = requests))
                }
              })
            } else {
              resolve(action === 'yes')
            }
          },
          buttons: {
            yes: approveText,
            no: 'Отмена',
            __showRequests: `Показать заявки на смежных объектах (${requests.length})`
          }
        })
      })
    }
  }
}
